(function(){
  'use strict';
  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn,{once:true});else fn();}
  function desktop(){return window.matchMedia?window.matchMedia('(min-width:1025px)').matches:window.innerWidth>=1025;}
  function q(root,sel){return (root||document).querySelector(sel);}
  function qa(root,sel){return Array.prototype.slice.call((root||document).querySelectorAll(sel));}

  function initStoreBreakdown(){
    if(!desktop())return;
    qa(document,'[data-lbx-stock-hub]').forEach(function(hub){
      if(hub.dataset.lbx100StoreReady==='1')return;
      hub.dataset.lbx100StoreReady='1';
      var trigger=q(hub,'[data-lbx-fast-stock]');
      var panel=q(hub,'[data-lbx-store-stock-panel]');
      if(!trigger||!panel)return;
      var timer=0;
      function eligible(){return panel.getAttribute('data-lbx-store-eligible')==='true'&&!panel.hidden;}
      function position(){
        if(!eligible())return;
        var r=trigger.getBoundingClientRect();
        var width=Math.min(410,Math.max(300,window.innerWidth-32));
        var left=Math.max(16,Math.min(r.left,window.innerWidth-width-16));
        var estimated=170;
        var top=r.bottom+10;
        if(top+estimated>window.innerHeight-16)top=Math.max(16,r.top-estimated-10);
        panel.style.setProperty('--lbx100-stock-left',left+'px');
        panel.style.setProperty('--lbx100-stock-top',top+'px');
      }
      function open(){
        if(!eligible())return;
        window.clearTimeout(timer);
        position();
        hub.classList.add('is-lbx100-stock-open');
        panel.classList.add('is-lbx100-stock-open');
        trigger.setAttribute('aria-expanded','true');
      }
      function closeSoon(){
        window.clearTimeout(timer);
        timer=window.setTimeout(function(){
          if(trigger.matches(':hover')||panel.matches(':hover')||hub.contains(document.activeElement)||panel.contains(document.activeElement))return;
          hub.classList.remove('is-lbx100-stock-open');
          panel.classList.remove('is-lbx100-stock-open');
          trigger.setAttribute('aria-expanded','false');
        },120);
      }
      trigger.setAttribute('tabindex','0');
      trigger.setAttribute('aria-haspopup','dialog');
      trigger.setAttribute('title','Ver disponibilidad por tienda');
      trigger.addEventListener('mouseenter',open);
      trigger.addEventListener('focus',open);
      trigger.addEventListener('mouseleave',closeSoon);
      trigger.addEventListener('blur',closeSoon);
      panel.addEventListener('mouseenter',function(){window.clearTimeout(timer);});
      panel.addEventListener('mouseleave',closeSoon);
      trigger.addEventListener('click',function(e){
        if(!eligible())return;
        e.preventDefault();
        if(hub.classList.contains('is-lbx100-stock-open')){
          hub.classList.remove('is-lbx100-stock-open');
          panel.classList.remove('is-lbx100-stock-open');
          trigger.setAttribute('aria-expanded','false');
        }else open();
      });
      window.addEventListener('resize',function(){if(hub.classList.contains('is-lbx100-stock-open'))position();},{passive:true});
      window.addEventListener('scroll',function(){if(hub.classList.contains('is-lbx100-stock-open'))position();},{passive:true});
    });
  }

  function init(){initStoreBreakdown();}
  ready(init);
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('variant:change',function(){window.setTimeout(initStoreBreakdown,30);});
})();
